import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [user, setUser] = useState(null);

  const refreshSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
  }, []);

  useEffect(() => {
    refreshSettings();
    if (!localStorage.getItem("tdba_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("tdba_token");
      setUser(false);
    });
  }, [refreshSettings]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tdba_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("tdba_token");
    setUser(false);
  };

  return (
    <SiteContext.Provider value={{ settings, refreshSettings, user, login, logout }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);

export const useContent = (resource, admin = false) => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);
  const load = useCallback(() => api.get(`${admin ? "/admin" : ""}/content/${resource}`).then((r) => { setItems(r.data); setError(false); }).catch(() => { setItems([]); setError(true); }), [resource, admin]);
  useEffect(() => { load(); }, [load]);
  return { items, error, reload: load };
};
